import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import {useSubscription} from "../../subscription/useSubscription";
import {ExploreSection} from "./ExploreSection";
import {PortfolioHeader} from "../portfolio/PortfolioHeader";
import CompanyWithinPortfolioLink from "../company/CompanyWithinPortfolioLink";
import ExploreNavigation from "./ExploreNavigation";
import exploreActionsFactory from "./exploreActions";
import KpiChooser, {ValueChooser} from "../kpi/KpiChooser";
import OurProgrammeContext, {exploreSubscriptionUrl} from "../navigation/OurProgrammeContext";
import {CentredLoader} from "../../elements/Loader";

const PortfolioExplorePage = ({}) => {
    const params = useParams();
    const history = useHistory();
    const groupingData = useSelector(state => state.explore);
    useSubscription("EXPLORE_CUSTOM_GROUPING", exploreSubscriptionUrl(params, groupingData.filter), 60);
    const dispatch = useDispatch();
    const exploreActions = exploreActionsFactory(dispatch);
    useEffect(() => {
        return () => {
            exploreActions.reset();
        };
    }, []);

    if (!(groupingData && groupingData.settings && groupingData.settings.portfolioName)) {
        return <div style={{padding: 20}}><CentredLoader /></div>;
    }

    const {portfolioId} = params;
    const {settings, overallGrouping, availablePeriods, firstGroupingName, secondGroupingName} = groupingData;
    const {portfolioName, portfolioCompanyName} = settings;

    const loggingPayload = {
        type: "EXPLORE_PAGE_NAVIGATION",
        portfolioId,
        portfolioName,
        firstGroupingName,
        secondGroupingName
    };

    const kpiChooser = new KpiChooser(settings);
    const valueChooser = new ValueChooser(settings);

    const ourProgrammeContext = new OurProgrammeContext(params, portfolioName, null, settings.rewardPeriod);
    const navigation = new ExploreNavigation(ourProgrammeContext);
    const navigate = navigation.onSecondaryGrouping(history);
    const onSecondaryGrouping = (secondGrouping) => {
        exploreActions.setLoading(true);
        navigate(secondGrouping);
    };

    const linkGenerator = (contributorCompanyId, contributorCompanyName, children) => (
        <CompanyWithinPortfolioLink
            key={contributorCompanyId}
            ourProgrammeContext={ourProgrammeContext}
            portfolioCompanyName={portfolioCompanyName}
            contributorCompanyId={contributorCompanyId}
            contributorCompanyName={contributorCompanyName}>
            {children}
        </CompanyWithinPortfolioLink>);


    const companyWithinPortfolioLinkGenerator = firstGroupingName === "author-company"
        ? linkGenerator
        : undefined;


    return (
        <div>
            <PortfolioHeader settings={settings}
                             overallGrouping={overallGrouping}
                             selectedKpi={kpiChooser.selectedKpi({isAdditionalGrouping: false})}
                             periods={availablePeriods}
                             ourProgrammeContext={ourProgrammeContext}
            />
            <ExploreSection customGrouping={groupingData}
                            kpiChooser={kpiChooser}
                            valueChooser={valueChooser}
                            canSeeAllComponents={settings.owns}
                            isLoading={groupingData.isLoading}
                            backToPortfolioPage={navigation.backToPortfolioPage(history)}
                            onSecondaryGrouping={onSecondaryGrouping}
                            rowLinkGenerator={companyWithinPortfolioLinkGenerator}
                            totalPages={groupingData.grouping.totalPages}
                            pageNumber={groupingData.grouping.pageNumber}
                            pageNumberToUrlFunction={ourProgrammeContext.explorePagePath.bind(ourProgrammeContext)}
                            ourProgrammeContext={ourProgrammeContext}
                            loggingPayload={loggingPayload}
                            applyFilter={exploreActions.applyFilter}
                            pageName="PortfolioExplorePage"
            />
        </div>
    );
};

export default PortfolioExplorePage;
